import $ from "jquery"
import _ from 'underscore'

class TableCellRenderer {
    constructor()
    {
        this.extraCls = []
    }

    addExtraClass(cls)
    {
        this.extraCls.push(cls);
    }

    removeExtraClass(cls)
    {
        this.extraCls = _.filter(this.extraCls, (eCls) => eCls !== cls)
    }

    writeContent(cell)
    {
        this.generateContent(cell);
        this.updateUI(cell);
    }

    generateContent(cell)
    {
        cell.getCellEl().innerHTML = cell.getValue();
    }

    updateContent(cell)
    {
        // should be implemented if necessary
        // for example when you need to update only one cell with new data without recreating the whole row
        // see AssignTTApproversCell, AssignTTApproversCellRenderer
    }

    updateUI(cell)
    {
        let classesArray = this.getCellClassName(cell);
        this.appendToCellClassesArray(cell, classesArray);
        classesArray = this.concatExtraClasses(cell, classesArray);

        this.setCssClass(cell, classesArray.join(" "));
    }

    appendToCellClassesArray(cell, classesArray)
    {
        this.appendPositionClassesIfNeeded(cell, classesArray);
        this.appendSelectionClassesIfNeeded(cell, classesArray);
        this.appendHoverClassesIfNeeded(cell, classesArray);
    }

    appendPositionClassesIfNeeded(cell, classesArray)
    {
        if (cell.isFirst())
            classesArray.push("first");

        if (cell.isLast())
            classesArray.push("last");
    }

    appendSelectionClassesIfNeeded(cell, classesArray)
    {
        var selectionController = this.getSelectionController(cell);

        if (selectionController.getSelection().containsCell(cell))
            classesArray.push("selected");

        if (selectionController.hasSelection())
        {
            if (this.needsSelectionTopBorder(cell))
                classesArray.push("selectionTopBorder");
            if (this.needsSelectionRightBorder(cell))
                classesArray.push("selectionRightBorder");
            if (this.needsSelectionBottomBorder(cell))
                classesArray.push("selectionBottomBorder");
            if (this.needsSelectionLeftBorder(cell))
                classesArray.push("selectionLeftBorder");
        }
    }

    appendHoverClassesIfNeeded(cell, classesArray)
    {
        if (this.isHovered(cell))
            classesArray.push("hover");
    }

    concatExtraClasses(cell, classesArray)
    {
        return classesArray.concat(this.extraCls);
    }

    //noinspection JSUnusedLocalSymbols
    getCellClassName(cell)
    {
        return [];
    }

    needsSelectionTopBorder(cell)
    {
        const selection = this.getSelectionController(cell).getSelection();
        if (selection.containsCell(cell))
        {
            return selection.isUpwardmostCell(cell);
        }
        else
        {
            const upperCell = cell.upperCell();
            if (upperCell)
                return selection.containsCell(upperCell) && selection.isDownwardmostCell(upperCell);
        }

        return false;
    }

    needsSelectionRightBorder(cell)
    {
        if (cell.isLast())
        {
            const selection = this.getSelectionController(cell).getSelection();
            return selection.containsCell(cell);
        }

        return false;
    }

    needsSelectionLeftBorder(cell)
    {
        const selection = this.getSelectionController(cell).getSelection();
        if (selection.containsCell(cell))
        {
            return selection.isLeftmostCell(cell)
        }
        else
        {
            const leftCell = cell.leftCell();
            if (leftCell)
                return selection.containsCell(leftCell) && selection.isRightmostCell(leftCell);
        }

        return false;
    }

    needsSelectionBottomBorder(cell)
    {
        if (cell.getRow().isLast())
        {
            var selection = this.getSelectionController(cell).getSelection();
            return selection.containsCell(cell);
        }

        return false;
    }


    setCssClass(cell, cssClassName)
    {
        cell.getCellEl().className = cssClassName;
    }

    getSelectionController(cell)
    {
        return cell.getRow().getTable().getSelectionController();
    }

    getHoverController(cell)
    {
        return cell.getRow().getTable().getHoverController();
    }

    isSelected(cell)
    {
        return this.getSelectionController(cell).isSelected(cell.getRow().getRowIdx(), cell.getColIdx());
    }

    isHovered(cell)
    {
        return this.getHoverController(cell).isHovered(cell);
    }
}

export default TableCellRenderer



// WEBPACK FOOTER //
// ./web/js/table/TableCellRenderer.js